import push from '../../utils/routing';

export default (spaceId, materialSectionId) => () => {
  const url = materialSectionId
    ? `/dashboard/${spaceId}/journey/educatorArea/${materialSectionId}`
    : `/dashboard/${spaceId}/journey/educatorArea`;
  push(url);
};
